export enum Gender {
    MALE = "M",
    FEMALE = "F"
}